// Pension and benefits possible feature key values
export const NONE_FEATURE_VALUE = 0;
export const PENSION_FEATURE_VALUE = 1;
export const BENEFIT_FEATURE_VALUE = 2;
export const BOTH_FEATURE_VALUE = 3;

// Max visible plan item count in Benefits card before 'Load More' click
export const BENEFIT_MAX_PLAN_ITEM_COUNT = 6;
